import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const blogLinks = {
  en: [
    {
      href: "/blogs/is_bluetooth_le_right_for_your_product",
      label: "Is Bluetooth LE right for your product?",
    },
    {
      href: "/blogs/bluetooth_le_product_architecture",
      label: "Bluetooth LE product architecture",
    },
    {
      href: "/blogs/ble_mobile_application_support",
      label: "BLE mobile application support",
    },
    {
      href: "/blogs/ble_embedded_development_platforms",
      label: "Best platforms for Bluetooth LE development",
    },
    {
      href: "/blogs/auracast_mcu",
      label: "ESP32 Auracast: Does It Work? Best MCUs for LE Audio",
    },
    {
      href: "/blogs/ble_hardware_2026",
      label: "Best hardware for Bluetooth Low Energy BLE development in 2026",
    },
  ],
  pl: [
    {
      href: "/pl/blogs/cennik-aplikacje-mobilne",
      label: "Ile kosztuje stworzenie aplikacji mobilnej lub webowej?",
    },
    {
      href: "/pl/blogs/is_bluetooth_le_right_for_your_product",
      label: "Czy Bluetooth LE to właściwa technologia?",
    },
    {
      href: "/pl/blogs/bluetooth_le_product_architecture",
      label: "Architektura produktu opartego o Bluetooth LE",
    },
    {
      href: "/pl/blogs/ble_mobile_application_support",
      label: "Wsparcie BLE po stronie aplikacji mobilnej",
    },
    {
      href: "/pl/blogs/ble_embedded_development_platforms",
      label: "Najlepsze platformy Bluetooth LE",
    },
    {
      href: "/pl/blogs/auracast_mcu",
      label: "ESP32 Auracast: czy działa? Najlepsze MCU do LE Audio",
    },
    {
      href: "/pl/blogs/ble_hardware_2026",
      label: "Najlepszy hardware BLE w 2026 roku",
    },
  ],
};

export const KnowledgeBase = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const links = blogLinks[(locale as "pl" | "en") ?? "en"] ?? blogLinks.en;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        gap: "10px",
      }}
    >
      <Typography component="h2" variant="subtitle">
        {t("footer.knowledge_base")}
      </Typography>

      {links.map(({ href, label }) => (
        <Link key={href} href={href} style={{ textDecoration: "none" }}>
          <Typography
            variant="code1"
            sx={{ "&:hover": { textDecoration: "underline" } }}
          >
            {label}
          </Typography>
        </Link>
      ))}
    </Box>
  );
};
